import React from "react";

export const WindowsLogo = ({ color = "currentColor" }: { color?: string }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={18}
		height={18}
		viewBox="0 0 30 30"
	>
		<path
			fill={color}
			d="M12 16H3v7.75l9 1.238zm0-11L3 6.25V14h9zm2-.25V14h13V3zM14 16v9.25L27 27V16z"
		/>
	</svg>
);
